<template>
  <v-layout row wrap pa-3>
    <v-flex xs12 md8 wrap>
      <v-layout column wrap main-section>
        <v-flex pt-3 wrap>
          <v-card-title>
            <!-- <h3 class="halfwhite-text">
                {{ $store.getters.getHeadingForBalanceBlock }}
              </h3> -->
            <v-icon>mdi-help-circle-outline</v-icon>
            <h4 class="headline halfwhite-text ml-2">Support</h4>
          </v-card-title>
          <v-card color="white" class="rounded ml-3 mt-3">
            <v-card-text>
              <div id="ovation_support"></div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex></v-flex>
    <v-flex xs12 md3 px-3 mt-4 mr-2>
      <v-layout column wrap mt-4>
        <BalanceColumn></BalanceColumn>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import BalanceColumn from "@/components/BalanceColumn";

export default {
  name: "Support",
  components: { BalanceColumn },
  data() {
    return {};
  },
  beforeMount() {
    hbspt.forms.create({
      region: "na1",
      portalId: "4536150",
      formId: "48fe0100-91f3-47e1-8ed6-5a4081e616dd",
      target: "#ovation_support",
    });
  },
};
</script>

<style scoped>
input[type="submit"] {
  margin: 0 25%;
  color: #ffffff;
  background-color: #d13b55 !important;
  border-radius: 6px;
  cursor: pointer;
  border-style: none;
  user-select: none;
  outline: none;
  font-size: 16px;
  font-weight: 500;
  line-height: 28px;
  padding: 4px;
  width: 50%;
  box-shadow: 1px;
}
</style>